<template>
    <div class="y-video-modal" v-if="active" @click="close">
      <div class="close"><CloseIcon/></div>
      <iframe :src="this.srcAttribute"/>
    </div>
</template>

<script>
import CloseIcon from "../assets/svg/close.svg"

export default {
  name: 'YouTubeVideoModal',
  components: {
    CloseIcon
  },
  props: {
    aspectRatio: {
      type: String,
      default: '16:9',
      validator: value => {
        const pattern = /^\d+:\d+$/
        return pattern.test(value)
      },
    },
    iframeAttributes: {
      type: Object,
      default: () => ({
        allowfullscreen: true,
        frameborder: 0,
        allow:
          'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
      }),
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    thumbnailListeners: {
      type: Object,
    },
  },
  mounted() {
  },
  computed: {
    active() {
      return this.$store.state.youtube.activeVideoId != '';
    },
    srcAttribute() {
      return `https://www.youtube-nocookie.com/embed/${this.id()}?autoplay=1`
    },
    styleObj() {
      return {
        paddingBottom: this.getPaddingBottom(),
      }
    }
  },
  methods: {
    id() {
      return this.$store.state.youtube.activeVideoId;
    },
    close() {
      this.$store.commit('activeVideo', '')
    }
  }
}
</script>

<style scoped lang="scss">
.y-video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.3);
  padding: 75px 5% 75px 5%;
  box-sizing: border-box;
  .close {
    position: absolute;
    width: 50px;
    height: 50px;
    right: 25px;
    top: 10px;
    cursor: pointer;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  iframe {
    width: 100%;
    height: 100%;
    background-color: #000000;
  }
}
</style>

